<h4 mat-dialog-title><i class="fas fa-check-circle mr-1"></i> Menu</h4>

<mat-dialog-content class="mat-typography">
    <div>
        <form class="example-form input-content" [formGroup]="form">
            <mat-form-field class="example-full-width">
                <mat-label>Privilege name</mat-label>
                <input type="text" autocomplete="off" matInput formControlName="privilegeName" aria-label="Privilege name">
            </mat-form-field>

            <mat-form-field class="example-full-width">
                <mat-label>Menu name</mat-label>
                <input type="text" autocomplete="off" matInput formControlName="menuName" aria-label="Menu name">
            </mat-form-field>

            <mat-form-field class="example-full-width">
                <mat-label>Menu css class</mat-label>
                <input type="text" autocomplete="off" matInput formControlName="menuCssClass" aria-label="Menu css class">
            </mat-form-field>

            <mat-form-field class="example-full-width">
                <mat-label>Menu link</mat-label>
                <input autocomplete="off" matInput formControlName="menuHref" aria-label="Menu link">
            </mat-form-field>

            <mat-checkbox formControlName="status">Active</mat-checkbox>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-success float-right mr-2" type="submit" aria-label="update" [disabled]="!form.valid" (click)="update()"><i
            class="fas fa-plus mr-1"></i> Update</button>

    <button class="btn btn-light float-right" aria-label="cancle" (click)="closeDialog()">
        <i class="fas fa-times mr-1"></i> Cancel</button>
</mat-dialog-actions>
